import dayjs from 'dayjs';

export type DurationInfo = {
    months: number;
    days: number;
    hours: number;
    minutes: number;
    expired: boolean;
};

export const getDurationInfo = (timestamp: number, now = Date.now()) => {
    if (timestamp - now <= 0) {
        return {
            months: 0,
            days: 0,
            hours: 0,
            minutes: 0,
            expired: true,
        };
    }
    const timestampDayjs = dayjs(timestamp);
    const nowDayjs = dayjs(now);
    return {
        months: timestampDayjs.diff(nowDayjs, 'month'),
        days: timestampDayjs.diff(nowDayjs, 'day'),

        // hours and minutes come together, so minutes difference should remove the hours
        hours: timestampDayjs.diff(nowDayjs, 'hour'),
        minutes: timestampDayjs.diff(nowDayjs, 'minute') % 60,

        expired: false,
    };
};
